import Skeleton from './Skeleton';

export default function ImageViewWithCarouselSkeleton() {
  return (
    <div className="flex flex-col items-center justify-center">
      <Skeleton className="h-[380px] w-full rounded-2xl bg-gray-300 dark:bg-gray-700" />
      <Skeleton className="mt-1 h-[100px] w-[200px] rounded bg-gray-300 dark:bg-gray-700" />
      <Skeleton className="h-4 w-1/2 rounded-2xl bg-gray-300 dark:bg-gray-700" />
      <Skeleton className="mt-1 h-[100px] w-[200px] rounded bg-gray-300 dark:bg-gray-700" />
    </div>
  );
}
